<template>
  <section
    class="skeleton overview"
    :style="`background: linear-gradient(${gradient})`"
  >
    <div class="overview__top">
      <div class="skeleton__box overview__left">
        <p class="skeleton__content skeleton__animate--white"></p>
        <h4
          class="skeleton__title skeleton__animate--white overview__title"
        ></h4>
        <p class="skeleton__content skeleton__animate--white"></p>
        <p class="skeleton__content skeleton__animate--white"></p>
        <p class="skeleton__content skeleton__animate--white"></p>
        <p class="skeleton__content skeleton__animate--white"></p>
        <p class="skeleton__content skeleton__animate--white"></p>
        <p class="skeleton__content skeleton__animate--white"></p>
        <p class="skeleton__content skeleton__animate--white"></p>
        <p class="skeleton__content skeleton__animate--white"></p>
        <p class="skeleton__content skeleton__animate--white"></p>
      </div>
      <div class="skeleton__box skeleton__animate overview__right"></div>
    </div>
    <div class="overview__bottom">
      <div class="skeleton__box skeleton__animate overview__bottom-box">
        <div class="skeleton__animate--white overview__profile"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CourseOverviewSkel',
  props: {
    gradient: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.overview {
  min-height: 50vh;
  padding: 150px 10px 25px 10px;
  @include tablet {
    padding: 150px 75px 25px 75px;
  }
  &__top {
    display: flex;
  }
  &__left {
    height: 350px;
    width: 100%;
    margin: 0 25px 0 0;
    padding: 0 10px;
    @include tablet {
      width: 50%;
      padding: 0 25px 0 0;
    }
    @include desktop {
      padding: 0 75px 0 0;
    }
    @include lg-desktop {
      padding: 0 100px 0 0;
    }
  }
  &__right {
    height: 300px;
    display: none;
    width: 100%;
    @include tablet {
      display: flex;
      align-items: center;
      padding: 0 0 0 25px;
      width: 45%;
    }
    @include desktop {
      margin: 20px 0 0 0;
    }
    @include lg-desktop {
      padding: 0 0 0 100px;
    }
  }
  &__profile {
    border-radius: 100%;
    height: 170px;
    width: 170px;
    position: absolute;
    top: -75px;
  }
  &__bottom {
    height: 117px;
    display: flex;
    margin: 200px 0 0 0;
  }
  &__bottom-box {
    width: 100%;
    @include tablet {
      margin: 0 25px;
    }
  }
}
</style>
